export default {
    name: 'calculatorsFed',
    serverName: '/api/v1/fed_calculator/fed_calculator/',
    apiUrl: '/api/v1/fed_calculator/fed_calculator/'
};
